module.exports = __webpack_public_path__ + "img/1440x720.e0e36b13.png";